// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kb-0";